import React, { Component } from 'react';
import './DropdownDatePicker.scss';
import utils from '../../utils/utils';
import Validation from '../validation/Validation';
import FontIcon from "../fontIcon/FontIcon";

const formatValue = (datetime) => {
	if (!datetime) return '';
	if (!datetime.getMonth) return '';
	let month = (datetime.getMonth() + 1 + '').padStart(2, '0');
	let day = (datetime.getDate() + '').padStart(2, '0');
	let dtArray = [datetime.getFullYear(), month, day];
	return dtArray.join('-');
};

const fromDateString = (dateString) => {
	const [year, month, day] = dateString.split('-').map(Number);
	return new Date(year, month - 1, day);
};

const getMonthName = (monthNumber) => {
	const months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	];
	return months[monthNumber - 1] || '';
};

const getMonthNumber = (monthName) => {
	const months = {
		'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
		'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
	};
	return months[monthName] || 1;
};

const getDaysInMonth = (year, month) => {
	return new Date(year, month, 0).getDate();
};

const getYears = (props) => {
	const currentYear = new Date().getFullYear();
	const years = [];
	for (let i = currentYear - (props.previousYears || 5); i <= currentYear + (props.futureYears || 100); i++) {
		years.push(i);
	}
	return years;
};

const getMonths = () => {
	return [
		'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	];
};

const getDays = (year, month) => {
	const daysInMonth = getDaysInMonth(year, month);
	const days = [];
	for (let i = 1; i <= daysInMonth; i++) {
		days.push(i);
	}
	return days;
};

export default class DropdownDatePicker extends Component {
	constructor(props) {
		super(props);
		const initialDate = typeof this.props.value === 'string' ? fromDateString(this.props.value) : this.props.value;
		this.state = {
			value: initialDate,
			valid: true,
			openDropdown: null, // 'month', 'day', 'year', or null
			month: initialDate ? initialDate.getMonth() + 1 : null,
			day: initialDate ? initialDate.getDate() : null,
			year: initialDate ? initialDate.getFullYear() : null
		};
	}

	componentDidMount() {
		document.addEventListener('mousedown', this._checkForOutsideClick, false);
		document.addEventListener('touchstart', this._checkForOutsideClick, false);
		if (this.props.autoFocus) {
			// Focus the first dropdown
			this.monthRef && this.monthRef.focus();
		}
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this._checkForOutsideClick, false);
		document.removeEventListener('touchstart', this._checkForOutsideClick, false);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (this.props.uncontrolled) {
			const newDate = typeof nextProps.value === 'string' ? fromDateString(nextProps.value) : nextProps.value;
			this.setState({ 
				value: newDate,
				month: newDate ? newDate.getMonth() + 1 : null,
				day: newDate ? newDate.getDate() : null,
				year: newDate ? newDate.getFullYear() : null
			});
		}
	}

	isValid = () => {
		let valid = true;
		let date = formatValue(this.state.value);
		if (!utils.is_client_date(new Date(date))) {
			valid = false;
		}
		if (this.props.required && !date) {
			valid = false;
		}
		this.setState({ valid });
		return valid;
	};

	getValue = () => {
		return formatValue(this.state.value);
	};

	onChange = (newDate) => {
		this.setState({ value: newDate }, () => {
			if (this.props.onChange) {
				this.props.onChange(formatValue(newDate));
				this.isValid();
			}
		});
	};

	onFocus = () => {
		utils.hideKeyboard();
	};

	renderClearButton = () => {
		return <FontIcon className={'icon-clear-value'} name="icon-close" onClick={this.clearValue}/>
	};

	clearValue = () => {
		this.setState({
			value: null,
			month: null,
			day: null,
			year: null
		});
		this.props.onChange(null);
	};

	renderInvalidText = () => {
		if (!this.state.valid) {
			return <Validation />;
		}
	};

	handleDropdownChange = (type, value) => {
		let newMonth = this.state.month;
		let newDay = this.state.day;
		let newYear = this.state.year;

		if (type === 'month') {
			newMonth = getMonthNumber(value);
		} else if (type === 'day') {
			newDay = parseInt(value);
		} else if (type === 'year') {
			newYear = parseInt(value);
		}

		// Validate the date
		if (newMonth && newDay && newYear) {
			const daysInMonth = getDaysInMonth(newYear, newMonth);
			if (newDay > daysInMonth) {
				newDay = daysInMonth;
			}
			const newDate = new Date(newYear, newMonth - 1, newDay);
			this.onChange(newDate);
		}

		this.setState({
			month: newMonth,
			day: newDay,
			year: newYear,
			openDropdown: null
		});
	};

	toggleDropdown = (type) => {
		this.setState({
			openDropdown: this.state.openDropdown === type ? null : type
		});
	};

	_checkForOutsideClick = (e) => {
		if (!this.element) return;
		if (!this.element.contains(e.target)) {
			if (this.state.openDropdown) {
				this.setState({ openDropdown: null });
			}
		}
	};

	renderDropdown = (type, options, selectedValue, placeholder) => {
		const isOpen = this.state.openDropdown === type;
		const displayValue = selectedValue ? 
			(type === 'month' ? getMonthName(selectedValue) : selectedValue) : 
			placeholder;

		return (
			<div className={`dropdown-field ${type}`}>
				<div 
					className={`dropdown-trigger ${isOpen ? 'open' : ''}`}
					onClick={() => this.toggleDropdown(type)}
				>
					<span className={"dropdown-value " + (displayValue===placeholder? 'placeholder': '')}>{displayValue}</span>
					<FontIcon name="icon-chevron-down" className="dropdown-arrow" />
				</div>
				{isOpen && (
					<div className="dropdown-options">
						{options.map((option, index) => (
							<div
								key={index}
								className={`dropdown-option ${selectedValue === option ? 'selected' : ''}`}
								onClick={() => this.handleDropdownChange(type, option)}
							>
								{type === 'month' ? option : option}
							</div>
						))}
					</div>
				)}
			</div>
		);
	};

	render() {
		const months = getMonths();
		const years = getYears(this.props);
		const days = this.state.year && this.state.month ? 
			getDays(this.state.year, this.state.month) : 
			Array.from({ length: 31 }, (_, i) => i + 1);

		return (
			<div 
				ref={(ref) => (this.element = ref)}
				className={"g-dropdown-date-picker " + (this.props.className || '')} 
				data-placeholder={this.state.value ? this.props.placeholder : ''}
			>
				{this.renderClearButton()}
				<div className="date-dropdowns">
					{this.renderDropdown('month', months, this.state.month, 'Month')}
					{this.renderDropdown('day', days, this.state.day, 'Day')}
					{this.renderDropdown('year', years, this.state.year, 'Year')}
				</div>
				{this.renderInvalidText()}
			</div>
		);
	}
}
